import React, {Component} from 'react'

import {Link} from 'react-router-dom'

import _ from 'lodash'

import {
  CardContent,
  Divider,
  // Typography,
} from 'material-ui'

import JobCardHeader from './JobCardHeader'
import AdminJobSummarySelectionPieChart from './AdminJobSummarySelectionPieChart'
import AdminJobSummaryApplicationsPieChart from './AdminJobSummaryApplicationsPieChart'
import AdminJobSummaryEndorsementsPieChart from './AdminJobSummaryEndorsementsPieChart'

import {
  Primary,
} from '../helper/consts'

import '../styles/Dashboard.css'

const style = {
  charts:{
    display:'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent:'space-around',
    alignItems:'center',
    width: '100%',
  },
  aboutHeader:{
    width:'100%',
    display: 'flex',
    flexDirection: 'column',
  },
  chartContainer:{
    minWidth:300,
    display:'flex',
    flexDirection:'column',
    justifyContent:'center',
    alignItems:'center',
    padding: '25px 0px',
  },
  titleLink:{
    textDecoration: 'underline',
    color: Primary,
  }
}

export default class AdminJobSummaryCard extends Component{
  render(){
    const {job,selectionStages} = this.props;
    let endorsements = job.endorsements || {};
    let endorsementsCount = 0;
    endorsementsCount = Object.keys(endorsements)
      .map( end => endorsements[end] )
      .reduce((sum,item)=>{return sum += _.size(item)},0)
    return(
      <CardContent className='dashboardCardContent'>
        <div style={style.aboutHeader} >
          <JobCardHeader job={job} />
          <Divider />
        </div>
        <div style={style.charts} >
          <div style={style.chartContainer}>
            <Link style={style.titleLink} to={`/Applicants/${job.jid}`}>
              Ratings {`(${endorsementsCount})`}
            </Link>
            <AdminJobSummaryEndorsementsPieChart job={job} />
          </div>
          <div style={style.chartContainer}>
            <Link style={style.titleLink} to={`/Applicants/${job.jid}`}>
              Applicants {`(${_.size(job.applications)})`}
            </Link>
            <AdminJobSummaryApplicationsPieChart job={job} />
          </div>
          <div style={style.chartContainer}>
            <Link style={style.titleLink} to={`/Applicants/${job.jid}`}>
              Screened {`(${_.size(job.selections)})`}
            </Link>
            <AdminJobSummarySelectionPieChart job={job} selectionStages={selectionStages} />
          </div>
        </div>
      </CardContent>
    )
  }
}

// applications
// commission
// created
// status
// selections: number of hired vs screening vs interviewing etc.
// endorsements: number of 5* vs 4* etc.



// WEBPACK FOOTER //
// ./src/components/AdminJobSummaryCard.js